export default __webpack_public_path__ + "static/media/karima.efecc20f.jpg";